export default __webpack_public_path__ + "static/media/gift.bd08ba01.svg";